module.exports = __webpack_public_path__ + "static/orders-resume-5f40a80e5a225f149e18a89f254273c7.png";